import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import $ from "jquery";
import { Message, Divider, Input, Form, Schema, ButtonGroup, Container, Animation, Button } from 'rsuite';
import VideoPlayer from './VideoPlayer';
//import {withRouter} from './../Helper/red';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}


const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const model_new_comment = Schema.Model({
    dis: Schema.Types.StringType().isRequired('این فیلد الزامی است.').maxLength(250, 'حداکثر کارکتر 250 میباشد').pattern(/[-.،1234567890آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئآابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'لطفا به صورت فارسی تایپ نمایید'),
});




let videoJsOptions = {
    languages: 'fa',
    autoplay: false,
    fluid: true,
    liveui: true,
    playbackRates: [0.5, 1, 1.25, 1.5, 2],
    width: '311',
    height: '275',
    controls: true,
    preload: 'metadata',
};


export class Course_Single extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            cuorse_id: this.props.params.id,
            cuorse: null,
            archive: null,
            buyed: null,
            subed: null,
            curent_item: 0,
            video: null,
            step: 1,
            loader_1: null,
            comments: null,
            NewComment: null,
            NewCommenSend: null,
        };


    }


    // ---------------- componentDidMount--------------------------

    componentDidMount() {

        Send('page/course/single/' + this.state.cuorse_id, "", true).then((res) => {


            if (!res.data.course) {
                this.props.navigation('/404');
            }
            this.setState({
                cuorse: res.data.course,
                archive: res.data.archive,
                buyed: res.data.buyed,
                subed: res.data.subed,
                comments: res.data.comments,
            }, () => {


                res.data.archive.length > 0 && this.VideoPlay(0);
            });


        }).catch((err) => { });

        H1.NavHide();

    }

    // ---------------- componentWillUnmount--------------------------


    componentWillUnmount() {

        H1.NavShow();
    }



    // ---------------- addCart--------------------------

    addCart = () => {
        localStorage.setItem('cart', this.state.cuorse_id)
        localStorage.setItem('CartType', 'course')
        this.props.navigation('/cart');
    }




    // ---------------- VideoPlay--------------------------

    VideoPlay = (uid, scrl = null) => {

        this.setState({
            curent_item: uid,
            video: null,
        }, () => {
            H1.notfy_dismiss();


            let access = false;
            if (this.state.cuorse.pay === 'sub' && this.state.subed) {
                access = true;
            
            }

            else if (this.state.cuorse.pay === 'buy' && this.state.buyed) {
                access = true;
              
            }



            if (access == true || Number(this.state.archive[this.state.curent_item].free) == 1) {
          
                let videoJsOptions2 = {
                    ...videoJsOptions,
                    poster: this.state.archive[this.state.curent_item].cover,
                    sources: [{ 
                        src: this.state.archive[this.state.curent_item].link,
                     }]
                };
                this.setState({ video: videoJsOptions2 });
                if (scrl) {
                    H1.ScrollTop(0, 150);
                }

            }

            else {
                H1.notfy_error('شما دسترسی به این دوره ندارید');

            }



        });


    }

    //------------------ step_change-----------------------

    step_change = (id) => {

        this.setState({ step: id });

    }



    // ------------------------- NewComment ----------------------------
    NewComment = () => {


        this.setState({ loader_1: true });

        let data = {
            dis: this.state.NewComment.dis,
            item_id: this.state.cuorse_id,
            type: 'c',
        };

        Send('page/comment/new', data, false).then((res) => {
            H1.notfy_success(res.message)

            this.setState({ loader_1: false, NewCommenSend: true });
        }).catch((err) => {
            this.setState({ loader_1: false });
        });

    }


    // ------------------------- LikeCommnet ----------------------------
    LikeCommnet = (index) => {


        let data = {
            id: this.state.comments[index].id,
            item_id: this.state.comments[index].item_id,
            type: this.state.comments[index].likes_user ? 'decrement' : 'increment',
        };


        Send('page/comment/like', data, false).then((res) => {
            this.setState({ comments: res.data.comments });
        }).catch((err) => { });

    }


    render() {

        this.state.cuorse && H1.page_name('دوره: ' + this.state.cuorse.name);

        return !this.state.cuorse ? null : (

            <div className={`h-100 mt-2 ${!this.state.buyed && 'mb-5'}`}>


                <Container className='c-row'>

                    <div className="text-center mb-2 py-2">

                        <span className="icon-Back float-end fs-3" onClick={() => this.props.navigation(-1)} ></span>

                    </div>

                </Container>



                {this.state.video &&

                    <Animation.Bounce in={true} >
                        <div className="c-row mt-1">
                            <div data-vjs-player className='br-16 video-box'>
                                <VideoPlayer className="w100" {...this.state.video} />
                            </div>
                        </div>
                    </Animation.Bounce>
                }


                {this.state.cuorse && this.state.cuorse.dis &&
                    <Container className='c-row mt-2'>
                        <p className='ws-br'>{this.state.cuorse.dis}</p>
                    </Container>
                }


                <div className="c-row mt-4">
                    <ButtonGroup justified className='ltr bg-white br-16'>
                        <Button className='py-3 br-16' appearance={this.state.step === 2 ? 'primary' : 'subtle'} onClick={() => this.step_change(2)} >دیدگاه‌ها</Button>
                        <Button className='py-3 br-16' appearance={this.state.step === 1 ? 'primary' : 'subtle'} onClick={() => this.step_change(1)}>جلسات</Button>
                    </ButtonGroup>
                </div>




                {this.state.step === 1 &&
                    <>



                        <div className="c-row mt-2">


                            {this.state.archive.length > 0 &&
                                <>

                                    <Animation.Slide in={true} placement="right">
                                        <h2 className='fs-3'>


                                            {this.state.archive[this.state.curent_item].title}

                                        </h2>
                                    </Animation.Slide>


                                    <div className="cc-2">
                                        {this.state.cuorse.archive_count} جلسه   <span className='mx-1'>●</span> {H1.TimeConvert(this.state.cuorse.archive_time, ['h', 'm'])}
                                    </div>


                                    {this.state.archive.map((item, index) => [

                                        <Animation.Slide in={true} transitionAppear={true} placement="bottom" key={index + 1}>
                                            <div className={`archive_item d-flex flex-row br-16 mt-3 py-3 px-3 ${index == this.state.curent_item ? 'bb-1' : 'bg-white'}`}>
                                                <div className="align-self-center index fs-24 cc-2 me-3 ltr "> {index < 9 && "0"}{index + 1}</div>
                                                <div className="align-self-center info">

                                                    <span className={`fw-bold ${index == this.state.curent_item ? 'text-white' : ''}`}>  {item.title}</span>
                                                    <div className="align-self-center time cc-2 fs-12 mt-1 ltr text-start">{item.time_m < 10 && "0"}{item.time_m} : {item.time_s < 10 && "0"}{item.time_s}</div>


                                                </div>

                                                <div className={`align-self-center ms-auto play cursor ${index == this.state.curent_item ? 'text-white' : 'cc-1'}`} onClick={() => this.VideoPlay(index, true)}>

                                                    {Number(item.free) || this.state.buyed || this.state.subed && this.state.cuorse.pay === 'sub' ?
                                                        <span className="icon-Play fs-1"></span>
                                                        : <span className="icon-lock fs-2"></span>
                                                    }


                                                </div>

                                            </div>
                                        </Animation.Slide>

                                    ])}

                                </>

                            }


                            {this.state.cuorse.pay === 'buy' && !this.state.buyed &&
                                <div className="buy_box d-flex justify-content-center">
                                    <Button appearance="primary" color='green' className='fw-light btn_s1 me-3' onClick={() => this.addCart()}> خرید دوره </Button>
                                    <span className="icon-Close CloseBtn" onClick={() => $('.buy_box').addClass('close')}></span>
                                </div>
                            }


                            {this.state.cuorse.pay === 'sub' && !this.state.subed &&
                                <div className="buy_box d-flex justify-content-center">
                                    <NavLink exact="true" to='/cart/sub'> <Button appearance="primary" color='green' className='fw-light btn_s1 me-3' > خرید اشتراک </Button> </NavLink>
                                    <span className="icon-Close CloseBtn" onClick={() => $('.buy_box').addClass('close')}></span>
                                </div>
                            }


                            {this.state.cuorse.is_live == 1 && this.state.cuorse.live_id &&
                                <div className="buy_box d-flex justify-content-center">
                                    <NavLink exact="true" to={`/live/${this.state.cuorse.id}`}>  <Button appearance="primary" color='red' className='fw-light btn_s1 me-3' > پخش زنده </Button> </NavLink>
                                    <span className="icon-Close CloseBtn" onClick={() => $('.buy_box').addClass('close')}></span>
                                </div>
                            }

                        </div>




                    </>
                }




                {this.state.step === 2 &&
                    <>

                        <div className="c-row mt-3">

                            <Animation.Slide in={true} placement="right">
                                <h2 className='fs-18'>  {this.state.comments ? this.state.comments.length : 0} دیدگاه </h2>
                            </Animation.Slide>


                            {this.state.comments && this.state.comments.map((item, index) => [

                                <>


                                    <Divider />




                                    <Animation.Slide in={true} placement="bottom" key={'comment_' + index}>
                                        <div className="comment_box px-3">
                                            <div className="head mb-2">
                                                <span className="user fw-bold"> {item.user && item.user.name_full} </span>
                                                <span className="date float-end cc-2">  ۲ روز پیش  </span>
                                            </div>

                                            <div className="dis mb-1">
                                                {item.dis ?? ''}
                                            </div>


                                            {item.reply &&
                                                <span className={`py-1 px-2`} appearance="subtle" color='red' >
                                                    <span className="icon-Comment"></span>
                                                </span>
                                            }



                                            <span className={`py-1 px-2 cursor ${item.likes_user && 'text-danger'}`} appearance="subtle" color='red' onClick={() => this.LikeCommnet(index)} >
                                                <span className="icon-Like"></span>   {item.like}
                                            </span>



                                            {item.reply &&
                                                <Message className='mt-1' type="info" header="پاسخ مربی:">
                                                    {item.reply}
                                                </Message>
                                            }


                                        </div>
                                    </Animation.Slide>
                                </>

                            ])}



                            <Divider />


                            {this.state.NewCommenSend ?


                                <Message showIcon type="info">
                                    دیدگاه شما پس از بررسی و تایید، قابل نمایش خواهد بود.
                                </Message>



                                :


                                <div className="new_write mt-3">
                                    <Form model={model_new_comment} checkTrigger='none' noValidate={true} align="middle" onChange={(val) => this.setState({ NewComment: val })} onCheck={(e) => H1.isEmpty(e) && this.NewComment()} >
                                        <Form.Group controlId="in_training" className='position-relative'>
                                            <Form.ControlLabel className="px-2" align="right">  دیدگاه خود را با دیگران در میان بگذارید </Form.ControlLabel>
                                            <Form.Control accepter={Textarea} rows={6} id="in_new_dis" name="dis" type="text" className='py-3 px-4 in_s1' placeholder='این‌جا تایپ کنید..' />
                                            <div className="ltr cc-2 fs-12 textarea_count">  <span className={`${this.state.NewComment && this.state.NewComment.dis.length > 250 ? 'text-danger' : ''}`}> {this.state.NewComment && this.state.NewComment.dis ? this.state.NewComment.dis.length : 0}  </span>     / 255  </div>
                                        </Form.Group>
                                        <Button appearance="primary" type="submit" block className='fw-light btn_s1 mx-auto' loading={this.state.loader_1}>ارسال</Button>
                                    </Form>
                                </div>


                            }






                        </div>

                    </>
                }









            </div>

        )

    }
}

export default withParams(Course_Single);
